// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout2_wrapper__2ogdV","user":"Layout2_user__1f76K","mainUser":"Layout2_mainUser__1y2qQ","topRow":"Layout2_topRow__2Rj_W","bottomRow":"Layout2_bottomRow__3qiYV"};